export const tr = {
    'search-input-text': 'Bul',
    'video-stock-search-input-text': 'Search video library'
};
